 
 import './admin_menu.css';
 import React, { useState, useRef, useEffect } from 'react';
import { signInWithGoogle, googleLogout, checkUserAuth } from '../firebase';
import { addDoc, collection } from "firebase/firestore"; 
import { db } from "../firebase";  // Import Firestore configuration
import { useNavigate, useLocation } from "react-router-dom";
import { MdOutlineSupportAgent, MdWorkHistory } from "react-icons/md";
import { AiOutlineHome, AiFillHome } from "react-icons/ai";
import { RiSlideshowLine, RiSlideshowFill } from "react-icons/ri";
import { BsPersonWorkspace } from "react-icons/bs";
import { BiSupport } from "react-icons/bi";
import { FaMessage, FaRegMessage } from "react-icons/fa6"; 
import Cookies from 'js-cookie';
import '../master_root/header.css'; 
import { IoAddCircle,IoAddCircleOutline } from "react-icons/io5";
export default function Adminmenu() {
        const navigate = useNavigate();
        const location = useLocation();
        const [user, setUser] = useState(null);
        const [messages, setmessages] = useState(0);
        const [guid, setGuid] = useState("");
        const [photoURL, setPhotoURL] = useState("");
        const [loginName, setLoginName] = useState("");
        // Automatically check for logged-in user on page load
        const [isOpen, setIsOpen] = useState(true);
    
       //login
      const [userlogin, setuserlogin] = useState(false); // State for popup
       const popupRef = useRef(null);    // Ref for direct DOM manipulation
     
     
       //prod 
     
       useEffect(() => {
         checkUserAuth(setUser);  // Auto-login
         const existingUser = Cookies.get("guid");   // Check for existing login
    
         if (existingUser != null) {
            setuserlogin(true);
             const photo=Cookies.get("login_photoURL");
     
             setPhotoURL(photo);
         } else {        
            setuserlogin(false);   // Auto-open login popup if not logged in
         }
       }, []);
    return (
    
                       <div className="menus_body admin-menu">
                                    <div
                                        onClick={() => navigate('/admin')}
                                        className={`menubutton-icon ${location.pathname === '/admin' ? 'active' : ''}`}
                                        title="Home"
                                    >
                                        {location.pathname === '/admin' ? <AiFillHome className="icon" /> : <AiOutlineHome className="icon" />}
                                        <span className="button-text">Home</span>
                                    </div>
                                    {userlogin==true && (
                                    <div
                                        onClick={() => navigate('/admin_jobcategories')}
                                        className={`menubutton-icon ${location.pathname === '/admin_jobcategories' ? 'active' : ''}`}
                                        title="job categories"
                                    >                              
                                        {location.pathname === '/admin_jobcategories' ? (
                                        <IoAddCircle className="icon" />
                                    ) : (
                                        <IoAddCircleOutline className="icon" />
                                    )}
                                      <span className="button-text">Categories</span>
                                    </div>
                                    )}
                                    <div
                                        onClick={() => navigate('/editor')}
                                        className={`menubutton-icon ${location.pathname === '/editor' ? 'active' : ''}`}
                                        title="Editor"
                                    >
                                           {location.pathname === '/editor' ? <BsPersonWorkspace className="icon" /> : <BsPersonWorkspace className="icon" />}
                                       
                                       <span className="button-text">Editor</span>
                                    </div>
                                 
                                    <div
                                        onClick={() => navigate('/task')}
                                        className={`menubutton-icon ${location.pathname === '/task' ? 'active' : ''}`}
                                        title="Jobs"
                                    >
                                            {location.pathname === '/task' ? <RiSlideshowFill className="icon" /> : <RiSlideshowLine className="icon" />}
                                     
                                      <span className="button-text">Task</span>
                                    </div>
            
                                    <div
                                        onClick={() => navigate('/messageing')}
                                        className={`messageingmenubutton-icon ${location.pathname === '/messageing' ? 'active' : ''}`}
                                        title="Messaging"
                                    >
                                       
                                        {location.pathname === '/messageing' ? <FaMessage className="icon" /> : <FaRegMessage className="icon" />}
                                        <span className="button-text">Messaging</span>
                                        {messages > 0 && (
                                            <span className='message_count'>{messages}</span>
                                            )}
                                                                        
                                    </div>
            
                                    <div
                                        onClick={() => navigate('/advisers')}
                                        className={`submenubutton-icon ${location.pathname === '/advisers' ? 'active' : ''}`}
                                        title="Advisers"
                                    >
                                        {location.pathname === '/advisers' ? <BiSupport className="icon" /> : <MdOutlineSupportAgent className="icon" />}
                                        <span className="button-text">Advisers</span>
                                    </div>
                                </div>
          
    )
};